import ApolloClientService from './apolloclient.service'
import { constants } from '../constants'

const service = new ApolloClientService()

export default class Notification {
  setWebToken = (input) => {
    return new Promise((resolve, reject) => {
      service
        .setWebToken(input)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            reject(data)
          }
        })
        .catch((err) => {
          console.log(err, 'setWebToken')
        })
    })
  }
}
